import { useMutation } from '@gogame/query';

import { moveCreative } from 'scenes/Gallery/GalleryPage/Creatives/sources/creatives';

import { move } from '../queryKeyFactory';

export const useMoveTo = () => {
  const mutation = useMutation(move(), moveCreative, {
    successMessage: () => 'Creative moved to another concept',
  });

  const handleAction = async (params) => {
    await mutation.mutateAsync(params);
  };

  return [handleAction, mutation];
};
